import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
export function FinalCta() {
  return <section className="bg-concrete-900" aria-labelledby="cierre" data-id="element-81" data-mp="vghfvkydo5mw">
      <div className="hazard-bar h-3 w-full" aria-hidden="true" data-id="element-82" data-mp="19fgx47jk9i91" />
      <div className="mx-auto max-w-4xl px-5 py-16 text-center sm:px-8 sm:py-24" data-id="element-83" data-mp="19cmbicot9re1">
        <h2 id="cierre" className="font-display text-4xl uppercase leading-[0.95] text-concrete-50 sm:text-6xl" data-id="element-84" data-mp="15c2ed948mnrw">
          Tu momento es <span className="text-safety" data-id="element-85" data-mp="1eetqzc8unpl4">ahora o nunca</span> 🚀
        </h2>
        <p className="mx-auto mt-6 max-w-2xl text-lg leading-relaxed text-concrete-200 sm:text-xl" data-id="element-86" data-mp="1t2omt1i5ma2f">
          El "sueño americano" también se construye de este lado. No esperes a que
          tu cuerpo ya no pueda más. Da el salto hoy y empieza a ganar como jefe.
        </p>
        <CtaButton size="lg" className="mt-9 w-full sm:w-auto" data-id="element-87" data-mp="221jp42i2v00g">
          Quiero mi Megapack por $25 USD
          <ArrowRightIcon className="h-6 w-6 shrink-0" aria-hidden="true" data-id="element-88" data-mp="1x2p0gjxfih8f" />
        </CtaButton>
        <p className="mt-5 text-sm text-concrete-400" data-id="element-89" data-mp="n7ywt3r1xmqj">
          Descarga inmediata · Tarjetas y OXXO · Garantía de 7 días
        </p>
      </div>
    </section>;
}